import {
  base_colorAction,
  base_colorContentBorder,
  base_colorSurface,
  base_colorSurfaceMuted,
  text_colorTextPrimary,
  text_colorTextSecondary,
  warning_text,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_semibold } from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * Anchored under the card cluster (the shell's right column is the positioned
 * ancestor). z-index sits above the sticky Subnav below; the shell's Header
 * wrapper already establishes a stacking context above it.
 */
export const panel = css`
  position: absolute;
  top: calc(100% + ${spacing(2)});
  right: 0;
  z-index: 80;
  width: 300px;
  max-width: 100%;
  background-color: ${base_colorSurface};
  border: 1px solid ${base_colorContentBorder};
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(20, 20, 43, 0.1);
  overflow: hidden;
`

export const header = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing(3)} ${spacing(4)} ${spacing(3)};
`

export const headerLabel = css`
  font-family: ${font_family_weight_semibold};
  font-size: 11px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${text_colorTextSecondary};
`

export const body = css`
  padding: 0 ${spacing(4)} ${spacing(3)};
  font-size: 14px;
  line-height: 1.55;
  color: ${text_colorTextPrimary};
`

export const footer = css`
  display: flex;
  gap: ${spacing(5)};
  flex-wrap: wrap;
  padding: ${spacing(3)} ${spacing(4)};
  border-top: 1px solid ${base_colorContentBorder};
  background-color: ${base_colorSurfaceMuted};
`

export const detailGroup = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1.5)};
`

export const detailLabel = css`
  color: ${text_colorTextSecondary};
  font-size: 12px;
`

export const detailValue = css`
  color: ${text_colorTextPrimary};
  font-size: 12px;
  font-variant-numeric: tabular-nums;
`

export const copyGroup = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const copyButton = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(1)};
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  font-family: inherit;
  font-size: 13px;
  color: ${base_colorAction};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
    border-radius: 2px;
  }
`

export const copyError = css`
  font-size: 12px;
  color: ${warning_text};
`

export const stateMessage = css`
  padding: ${spacing(4)};
  color: ${text_colorTextPrimary};
  font-size: 14px;
  line-height: 1.5;
`
